import { Component, OnInit, OnDestroy, ViewEncapsulation, Inject, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { switchMap, tap } from 'rxjs/operators';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { ThemeService, Theme } from './theme.service';
import { isNullOrEmpty } from '@awp/core/utils';
import { ThemeLoaderService } from './theme-loader.service';
import { MODE_INJECTION_TOKEN } from '@awp/core/config';

@Component({
  selector: 'ap-theme',
  templateUrl: './theme.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ThemeComponent implements OnInit, OnDestroy {

  themeId: string;
  themeFavIcon = 'theme-favicon';
  themeCss = 'theme-css';

  constructor(
    @Optional() @Inject(MODE_INJECTION_TOKEN) private mode: string,
    private activatedRoute: ActivatedRoute,
    public themeService: ThemeService,
    private themeLoader: ThemeLoaderService) {}

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(
        tap(() => this.themeService.reset()),
        switchMap(() => {
          return this.themeService.getTheme();
        }),
        tap((theme: Theme) => {
          this.themeId = theme.themeId;
          this.themeService.currentTheme = theme;
        }),
        tap((theme: Theme) => {
          if (!isNullOrEmpty(theme.pageTitle)) {
            this.themeLoader.setTitle(theme.pageTitle);
          }
        }),
        tap((theme: Theme) => {
          if (theme.favIcon != null && !isNullOrEmpty(theme.favIcon.href)) {
            this.themeLoader.setFavIcon(theme.favIcon.href);
          }
        }),
        untilDestroyed(this),
      )
      .subscribe(theme => {
        if (this.mode != 'local' && theme.url != null && !isNullOrEmpty(theme.url.cssUrl)) {
          this.themeLoader.setCssNode(this.themeCss, theme.url.cssUrl)
            .then(() => this.themeService.complete());
        } else {
          this.themeService.complete();
        }
      });
  }

  ngOnDestroy(): void {}

}
